import Super from '../../core/button.gjs';
import styles from './primary.module.scss';

const METADATA = {
  component: 'Spds::Action::Button::Primary',
  description: `
    Primary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Primary Button',
  resources: {
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/primary.gjs',
  },
};

export default class SpdsActionButtonPrimary extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-primary';
  variantStyles = styles;
}

export const ACTION_BUTTON_PRIMARY_METADATA = SpdsActionButtonPrimary.metadata;
